<template>
  <ul class="link-list">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'LinkList',
}
</script>

<style scoped lang="scss">
.link-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
}
</style>
